import { useCallback, useState } from "react";

import { UsePriceOverridePanelReturn } from "./types";

/**
 * The panel can either be fixed to one row's instrument or select from
 * chart-derived candidates. Only the *request* is stored: the candidates for a
 * blocked chart date are derived from the holdings on every render, so a
 * holdings query that resolves after the panel opened still fills the select.
 */
export const usePriceOverridePanel = (): UsePriceOverridePanelReturn => {
  const [panel, setPanel] = useState<UsePriceOverridePanelReturn["panel"]>({
    isOpen: false,
    request: null,
  });

  const openPanel = useCallback<UsePriceOverridePanelReturn["openPanel"]>(
    (request) => {
      setPanel({ isOpen: true, request });
    },
    [],
  );

  const closePanel = useCallback(() => {
    setPanel((current) => ({ ...current, isOpen: false }));
  }, []);

  return { panel, openPanel, closePanel };
};
